import { GetProfileResponse } from "@services/models/Profile/GetProfileModel";
import { AxiosInstance } from "axios";
import { createApiClient } from "../api/createApiClient";

class ProfileApiService {
  private api: AxiosInstance;
  constructor() {
    this.api = createApiClient();
  }

  public async getProfile(): Promise<GetProfileResponse> {
    try {
      const response = await this.api.get(`/analyticsDashboard/getProfile`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const profileServices = new ProfileApiService();
